import Axios from '../utils/Axios';

export type hotelTitleLangType = {
  title_en: string | null;
  title_ch: string | null;
  title_ja: string | null;
  title_th: string | null;
  title_es: string | null;
  title_fr: string | null;
  title_ru: string | null;
  title_de: string | null;
};

export type hotelContentLangType = {
  content_en: string | null;
  content_ch: string | null;
  content_ja: string | null;
  content_th: string | null;
  content_es: string | null;
  content_fr: string | null;
  content_ru: string | null;
  content_de: string | null;
};

export type hotelCommentLangType = {
  comment: string | null;
  comment_en: string | null;
  comment_ch: string | null;
  comment_ja: string | null;
  comment_th: string | null;
  comment_es: string | null;
  comment_fr: string | null;
  comment_ru: string | null;
  comment_de: string | null;
};

export type HotelIntroType = hotelTitleLangType & {
  card_id?: number;
  title: string | null;
  card_id_order?: number;
  card_type?: number;
  url: string | null;
  resize_path_l?: string | null;
  resize_path_m?: string | null;
  resize_path_s?: string | null;
  card_content: HotelIntroCardType[];
  voucher_id: number | null;
  voucher_data?: HotelIntroVoucherType;
};

export type HotelIntroCardType = hotelContentLangType & {
  content_type?: number;
  url: string | null;
  resize_path_l?: string | null;
  resize_path_m?: string | null;
  resize_path_s?: string | null;
  content: string | null;
  content_id_order?: number;
};

export type HotelIntroVoucherType = hotelCommentLangType & {
  voucher_id?: number;
  benefit: string;
  benefit_en: string;
  phone_number: string;
  address: string;
  address_en: string;
  store_name: string;
  store_name_en: string;
  map_link: string;
  comment_translate_id?: number;
  end_date: string | null;
};

const StoreController = {
  getBcodeList: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getBcodeList';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[주소 검색 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setHotelBcode: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/setHotelBcode';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[배달구역 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 호텔 소개 불러오기
  getHotelIntro: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getHotelIntro';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 소개 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 호텔 소개 순서 변경하기
  editHotelIntroIdOrder: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/editHotelIntroIdOrder';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 소개 순서 변경하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 호텔 소개 추가하기
  setHotelIntro: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setHotelIntro';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 소개 추가하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 특정 호텔 소개 불러오기
  getHotelIntroCard: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getHotelIntroCard';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[특정 호텔 소개 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 메뉴 복사
  copyMenu: async (oParams: {
    target_store_id: number;
    source_store_id: number;
    admin_name: string;
  }) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/copyMenu';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[메뉴 복사]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 호텔 소개 수정하기
  editHotelIntro: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/editHotelIntro';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 소개 수정하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 호텔 소개 삭제하기
  delHotelIntro: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/delHotelIntro';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 소개 삭제하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  getStoreMetaByHotel: async (oParams?: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getStoreMetaByHotel';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장 리스트 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default StoreController;
